<template>
	<div>
		<div class="deatil_header">
			<span class="type_size_22">{{data.job_submit.job_name}}</span>
			<div class="p_flex p_f_a p_m_t_20">
				<div class="p_flex type_size_16 ">
					<span class="subject_color">{{data.job_submit.classLevel?data.job_submit.classLevel.name:''}}</span>
					<el-divider direction="vertical"></el-divider>
					<span class="subject_yellow">{{data.job_submit.subject_def}}</span>
					<el-divider direction="vertical"></el-divider>
					<span>{{data.job_submit.student_name}}</span>
					<el-divider direction="vertical"></el-divider>
					<span>{{data.job_submit.question_count}}道题</span>
					<el-divider direction="vertical"></el-divider>
					<span>{{data.job_submit.score}}分</span>
				</div>
				<span class="p_m_l_30">用时{{data.job_submit.use_minute}}分钟</span>
			</div>
			<div class="p_flex p_m_t_20 type_size_16">提交时间 {{data.job_submit.publish_date}} 至 {{data.job_submit.submit_date}}</div>
		</div>
		<span class="p_flex type_size_22 subject_color">全部题目</span>
		<div class="p_m_t_30">

			<div class="p_m_b_20" v-for="(item,index) in data.list" :key="index">
				<p  class="type_size_20" style="line-height:1">
					{{index+1}}.<!-- ({{item.question.year}}) -->
					<el-tag type="success" size="small " effect="dark">{{item.question.question_type_def}}</el-tag>
				</p>
				<div class="type_size_22">
					<span v-html="item.question.title"></span>
				</div>
				<div class="p_flex p_m_t_20 type_size_18">
					<div v-if="item.question.question_type == 1 || item.question.question_type == 2 || item.question.question_type == 5">
						答：{{item.content}}
					</div>

					<div v-else-if="item.question.question_type == 3">
						答：{{item.content == 'A' ? '对' : '错' }}
					</div>

					<div v-else-if="item.question.question_type == 4">
						答：<span v-for="(val,key) in item.content" :key="key">{{val.text}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
					</div>

					<div v-else-if="item.question.question_type == 6">
						<div v-for="(val,key) in item.content" :key="key" style="padding-left: 10px;">
							<span v-html="val.name"></span>
							<p style="padding-left: 10px; margin: 10px;">答：{{val.text}}</p>
						</div>
					</div>

				</div>

					<div style="margin: 25px 0 0;" v-if="item.question.analysis">
						解析：{{item.question.analysis}}
					</div>

				<div style="margin-top: 10px;" v-if="item.image && item.image.length > 0">
					<div v-if="item.answer_format == 'text'">
						<el-image style="width: 100px; height: 100px" v-for="(val,key) in item.image" :key="key" :src="val"  :preview-src-list="item.image"> </el-image>
					</div>
					<div v-else>
						<p >
							<el-image  style="width: 100px; height: 100px" v-for="(v,k) in item.image" :key="k" :src="v"  :preview-src-list="item.image"> </el-image>
						</p>

					</div>

				</div>
				<span class="p_flex p_m_t_20 type_size_22 subject_color p_f_e">
					<span v-if="item.result == 1">正确</span>
					<span style="color: #F1282E;" v-if="item.result == 2">错误</span>
					<span style="color: #FBB13C;" v-if="item.result == 3">待批改</span>
				</span>
			</div>

		</div>
	</div>
</template>

<script>
export default{
    props:{
        data: { type:Object, default:{ list:[], job_submit:{}, count:0 } },
	},
    data(){
        return {

        }
    },

}
</script>

<style lang="scss" scoped>
.deatil_header {
	padding: 30px 0;
}
.el-tag--dark.el-tag--success {
	background-color: #00af63;
	border-color: #00af63;
}
.deatil_img {
	width: 300px;
	height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/homes/already/commponents/deatilNot.vue